import React, { useMemo } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { LoadingButton } from "@mui/lab";
// import { MinimalTestPDFDocument } from "../api/minimal-test-pdf";
import { PendingPericiasPDFDocument, PendingPericiasPDFProps } from "../api/usePendingPericiasPDFCreator-react-pdf";

interface PendingPericiasPDFDownloadProps {
  props: PendingPericiasPDFProps;
  disabled?: boolean;
}

export const PendingPericiasPDFDownload: React.FC<PendingPericiasPDFDownloadProps> = ({ props, disabled = false }) => {
  const fileName = `pending_pericias_${props.costumer.name}_${props.start.toISOString().split("T")[0]}_${
    props.end.toISOString().split("T")[0]
  }.pdf`;

  // Debug logging
  console.log("PendingPericiasPDFDownload rendered with:", {
    periciaCount: props.pericias?.length || 0,
    timestamp: new Date().getTime()
  });

  // Store the first valid pericias data and never change it
  const stablePericias = React.useMemo(() => {
    if (props.pericias && props.pericias.length > 0) {
      console.log("Storing stable pericias data:", props.pericias.length);
      return props.pericias;
    }
    return null;
  }, [props.pericias?.length > 0]); // Only update when we go from no data to having data

  // Memoize the PDF document with stable data
  const pdfDocument = useMemo(() => {
    console.log("useMemo triggered. stablePericias:", stablePericias?.length || 0);

    // Only create PDF document if we have stable pericias data
    if (!stablePericias || stablePericias.length === 0) {
      console.log("No stable pericias data, returning null");
      return null;
    }

    console.log("Creating PDF document with", stablePericias.length, "pericias");

    // Create a frozen copy of the props to prevent external mutations during PDF generation
    const frozenProps: PendingPericiasPDFProps = {
      pericias: [...stablePericias], // Use stable pericias data
      costumer: { ...props.costumer }, // Shallow copy of costumer
      start: new Date(props.start), // New date instance
      end: new Date(props.end), // New date instance
      totalPrice: props.totalPrice,
      displayFields: { ...props.displayFields }, // Shallow copy of display fields
      periciaCount: stablePericias.length // Pass stable count explicitly
    };

    return <PendingPericiasPDFDocument {...frozenProps} />;
  }, [stablePericias, props.costumer.name, props.start.getTime(), props.end.getTime(), props.totalPrice, props.displayFields]); // Use stable dependencies

  // If no pericias data, show disabled button
  if (!pdfDocument) {
    return (
      <LoadingButton fullWidth variant="contained" sx={{ mb: 1, mt: 5 }} disabled>
        Aguardando dados...
      </LoadingButton>
    );
  }

  return (
    <PDFDownloadLink document={pdfDocument} fileName={fileName}>
      {({ loading }: { loading: boolean }) => (
        <LoadingButton fullWidth variant="contained" sx={{ mb: 1, mt: 5 }} disabled={disabled || loading} loading={loading}>
          {loading ? "Gerando PDF..." : "GERAR PDF DINÂMICO"}
        </LoadingButton>
      )}
    </PDFDownloadLink>
  );
};
